import { Link } from "react-router-dom";

function ClassLink({title, image, to}) {
    return (
        <div className="training-option">
            <Link to={to} className="training-option-link">
                <div className="icon"><img src={image} alt={title} /></div>
                <div className="training-option-title">{ title }</div>
            </Link>
        </div>
    );
}

export default ClassLink;